import * as React from 'react';
import './InnerFooterWrap.scss';

export interface IProps {}

export interface IFunctions {}

export type IAllProps = IProps & IFunctions;

export const InnerFooterWrap: React.SFC<IAllProps> = ({ children }) =>
    <div className="InnerFooterWrap-wrap">
        {children}
    </div>;

export default InnerFooterWrap;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/inner-footer-wrap/InnerFooterWrap.tsx